import styled from 'styled-components';

const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 15px;
	margin: 10px 0;
`;

const Line = styled.div`
	flex: 1;
	height: 1px;
	background-color: #dadce0;
`;

const Label = styled.span`
	font-family: 'Inter';
	font-size: 12px;
	line-height: 15px;
	color: rgba(0, 0, 0, 0.45);
`;

interface Props {
	children: React.ReactNode;
}

export const Delimiter = ({ children }: Props) => (
	<Container>
		<Line />
		<Label>{children}</Label>
		<Line />
	</Container>
);
